export default class {
    static calculateFinalScore = (x, y, z, weights) => this.applyWeight(x, weights.conversation) + this.applyWeight(y, weights.quality) + this.applyWeight(z, weights.community);

    static calculateWeightedNormalisedValue (metricValue, metricField, minVal, maxVal, weight) {
        let normalisedValue = this.calculateNormalisedValue(metricValue, metricField, minVal, maxVal);
        return this.applyWeight(normalisedValue, weight);
    }

    static getMaxValue (objectArray, propertyName) {
        let values = objectArray.map(o => o[propertyName]);
        return Math.max(...values);
    }

    static getMinValue (objectArray, propertyName) {
        let values = objectArray.map(o => o[propertyName]);
        return Math.min(...values);
    }

    static applyWeight (value, weight) {
        return (value && weight && weight > 0) ? (weight / 100) * value : 0;
    }

    static calculateNormalisedValue (metricValue, metricField, minVal, maxVal) {
        // The following formula is used to normalise the brand metric value.
        // normalisedValue = (((currentBrandMetricValue - MinimumBrandMetricValue) * 99) / (MaximumBrandMetricValue - MinimumBrandMetricValue)) + 1
        // Response time uses a different formula
        // normalisedValue = (((currentBrandMetricValue - MaximumBrandMetricValue) * 99) / (MinimumBrandMetricValue - MaximumBrandMetricValue)) +

        // If the min and max value is the same and the max value is not 0 then we assume that there will be only one metric.
        // Therefore we normalise the metric value to 100.
        if (maxVal > 0 && minVal === maxVal) {
            return 100;
        }

        if (metricField === 'facebookResponseTime' || metricField === 'twitterResponseTime') {
            return (metricValue && (minVal - maxVal) !== 0)
                ? (((metricValue - maxVal) * 99) / (minVal - maxVal)) + 1
                : 1;
        }
        return (metricValue && (maxVal - minVal) !== 0)
            ? (((metricValue - minVal) * 99) / (maxVal - minVal)) + 1
            : 1;
    }
}
